import { formatNumber } from '../../lib/formatters.js';

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business エラー画面別行内に表示するログイン状態別の小型水平スタックバー。loggedIn / anonymous の比率を視覚化する。
 * @graph-connects formatNumber [calls] 数値フォーマット
 */
export function AuthMiniBar({ loggedIn, anonymous }: { loggedIn: number; anonymous: number }) {
  const total = loggedIn + anonymous || 1;
  const liPct = (loggedIn / total) * 100;
  return (
    <div className="flex items-center gap-1.5 min-w-[120px]">
      <div className="flex h-3 flex-1 rounded-sm overflow-hidden">
        {loggedIn > 0 && (
          <div style={{ width: `${String(liPct)}%`, background: 'var(--chart-1)' }} />
        )}
        {anonymous > 0 && (
          <div style={{ width: `${String(100 - liPct)}%`, background: 'var(--chart-3)' }} />
        )}
      </div>
      <span className="text-[10px] font-mono text-[var(--color-text-muted)] whitespace-nowrap">
        {formatNumber(loggedIn)}/{formatNumber(anonymous)}
      </span>
    </div>
  );
}
